import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import SalesPage from "@/pages/SalesPage";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ChangePassword from "@/pages/ChangePassword";
import Admin from "@/pages/Admin";

import PortalLayout from "@/portal/PortalLayout";
import StartHere from "@/portal/StartHere";
import Training from "@/portal/Training";
import LessonPage from "@/portal/LessonPage";
import WeekendPlan from "@/portal/WeekendPlan";
import AssetVault from "@/portal/AssetVault";
import DemoOffer from "@/portal/DemoOffer";
import Scripts from "@/portal/Scripts";
import BookCall from "@/portal/BookCall";
import Support from "@/portal/Support";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SalesPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/change-password" element={<ProtectedRoute skipPasswordCheck><ChangePassword /></ProtectedRoute>} />

            <Route path="/portal" element={<ProtectedRoute><PortalLayout /></ProtectedRoute>}>
              <Route index element={<StartHere />} />
              <Route path="training" element={<Training />} />
              <Route path="training/:moduleId" element={<LessonPage />} />
              <Route path="weekend-plan" element={<WeekendPlan />} />
              <Route path="assets" element={<AssetVault />} />
              <Route path="demo-offer" element={<DemoOffer />} />
              <Route path="scripts" element={<Scripts />} />
              <Route path="book-call" element={<BookCall />} />
              <Route path="support" element={<Support />} />
              <Route path="admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
